import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Camera } from 'lucide-react';

export const CameraDialog = ({ open, onClose, videoRef, onCapture }) => {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="camera-dialog" className="sm:max-w-md">
        <DialogHeader><DialogTitle className="text-lg font-bold">Take Start Selfie</DialogTitle></DialogHeader>
        <div className="py-4">
          <div className="aspect-square bg-black rounded-lg overflow-hidden">
            <video ref={videoRef} autoPlay playsInline muted className="w-full h-full object-cover" style={{ transform: 'scaleX(-1)' }} />
          </div>
          <p className="text-xs text-slate-400 text-center mt-2">Position yourself in the frame and capture</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button data-testid="capture-selfie-btn" className="bg-emerald-600 hover:bg-emerald-700 text-white gap-2" onClick={onCapture}>
            <Camera className="w-4 h-4" /> Capture & Start
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
